import { render, staticRenderFns } from "./DatasetTile.vue?vue&type=template&id=f604f4b8&scoped=true"
import script from "./DatasetTile.vue?vue&type=script&lang=js"
export * from "./DatasetTile.vue?vue&type=script&lang=js"
import style0 from "./DatasetTile.vue?vue&type=style&index=0&id=f604f4b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f604f4b8",
  null
  
)

export default component.exports